import { render, staticRenderFns } from "./StateReportProblem.vue?vue&type=template&id=00e1c7bb&scoped=true&"
import script from "./StateReportProblem.vue?vue&type=script&lang=js&"
export * from "./StateReportProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e1c7bb",
  null
  
)

export default component.exports